import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;

const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        configs: {
            uploadFiles: {
                maxFiles: 3,
                mimeTypes: [
                    'application/msword',
                    'application/vnd.ms-excel',
                    'application/vnd.ms-powerpoint',
                    'application/pdf',
                    'image/x-png',
                    'image/jpeg',
                ],
            },
        },
        panels: {
            home: {
                menu: {
                    route: `portal.home`,
                    text: `home.title`,
                    icon: 'fas fa-home',
                },
                acl: {
                    view: 'GP_00001',
                },
            },
            dashboard: {
                menu: {
                    route: `portal.dashboard`,
                    text: 'dashboard.title',
                    icon: 'fas fa-th-large',
                },
                acl: {
                    view: null,
                },
            },
            settings: {
                menu: {
                    route: `${code}.settings`,
                    text: `settings.titles`,
                    icon: 'fas fa-cogs',
                },
                acl: {
                    view                    : 'GP_00030',
                    edit                    : 'GP_00031',
                },
                url: {
                    getConfig               : `${codeAPI}/gestao/settings`,
                    quickUpload             : `${codeAPI}/gestao/pages/quickupload`,
                },
            },
            news: {
                menu: {
                    route: `${code}.news`,
                    text: `news.titles`,
                    icon: 'fas fa-tasks',
                },
                acl: {
                    view                    : 'GP_00010',
                    detail                  : 'GP_00011',
                    add                     : 'GP_00012',
                    edit                    : 'GP_00013',
                    delete                  : 'GP_00014',
                },
                url: {
                    getList                 : `/${codeAPI}/gestao/news`,
                    getShow                 : `/${codeAPI}/gestao/news/:id`,
                    getCreate               : `/${codeAPI}/gestao/news`,
                    getUpdate               : `/${codeAPI}/gestao/news/:id`,
                    getDelete               : `/${codeAPI}/gestao/news/:id`,
                    getLists                : `/${codeAPI}/gestao/news/lists/:id`,
                    quickUpload             : `/${codeAPI}/gestao/news/quickupload`
                },
            },
            news_categories: {
                menu: {
                    route: `${code}.news_categories`,
                    text: `news_categories.titles`,
                    icon: 'fas fa-tasks',
                },
                acl: {
                    view                    : 'GP_00020',
                    detail                  : 'GP_00021',
                    add                     : 'GP_00022',
                    edit                    : 'GP_00023',
                    delete                  : 'GP_00024',
                },
                url: {
                    getList                 : `/${codeAPI}/gestao/newscategories`,
                    getShow                 : `/${codeAPI}/gestao/newscategories/:id`,
                    getCreate               : `/${codeAPI}/gestao/newscategories`,
                    getUpdate               : `/${codeAPI}/gestao/newscategories/:id`,
                    getDelete               : `/${codeAPI}/gestao/newscategories/:id`,
                    getLists                : `/${codeAPI}/gestao/newscategories/lists/:id`,
                },
            },
            pages: {
                menu: {
                    route: `${code}.pages`,
                    text: `pages.titles`,
                    icon: 'fas fa-tasks',
                },
                acl: {
                    view                    : 'GP_00040',
                    detail                  : 'GP_00041',
                    add                     : 'GP_00042',
                    edit                    : 'GP_00043',
                    delete                  : 'GP_00044',
                },
                url: {
                    getList                 : `/${codeAPI}/gestao/pages`,
                    getShow                 : `/${codeAPI}/gestao/pages/:id`,
                    getCreate               : `/${codeAPI}/gestao/pages`,
                    getUpdate               : `/${codeAPI}/gestao/pages/:id`,
                    getDelete               : `/${codeAPI}/gestao/pages/:id`,
                    getTypes                : `/${codeAPI}/gestao/pages/types`,
                    quickUpload             : `/${codeAPI}/gestao/pages/quickupload`
                },
            },
        },
        tools: {

        }
    }
};

export default state;
